
export const PAYS_AMERIQUE_SUD = [
  { code: 'AR', nom: 'Argentine', capitale: 'Buenos Aires', drapeau: '🇦🇷' },
  { code: 'BO', nom: 'Bolivie', capitale: 'Sucre / La Paz', drapeau: '🇧🇴' },
  { code: 'BR', nom: 'Brésil', capitale: 'Brasilia', drapeau: '🇧🇷' },
  { code: 'CL', nom: 'Chili', capitale: 'Santiago', drapeau: '🇨🇱' },
  { code: 'CO', nom: 'Colombie', capitale: 'Bogota', drapeau: '🇨🇴' },
  { code: 'EC', nom: 'Équateur', capitale: 'Quito', drapeau: '🇪🇨' },
  { code: 'GY', nom: 'Guyana', capitale: 'Georgetown', drapeau: '🇬🇾' },
  { code: 'PY', nom: 'Paraguay', capitale: 'Assomption', drapeau: '🇵🇾' },
  { code: 'PE', nom: 'Pérou', capitale: 'Lima', drapeau: '🇵🇪' },
  { code: 'SR', nom: 'Suriname', capitale: 'Paramaribo', drapeau: '🇸🇷' },
  { code: 'UY', nom: 'Uruguay', capitale: 'Montevideo', drapeau: '🇺🇾' },
  { code: 'VE', nom: 'Venezuela', capitale: 'Caracas', drapeau: '🇻🇪' }
];
